import React from "react";
import _ from "underscore";
import { underscored } from "underscore.string";
import PropTypes from "prop-types";
import HeaderWithIcon from "../common/HeaderWithIcon";
import Subchapter from "./Subchapter";
import { questionPropType } from "../../lib/dataShapes";

function Chapter({ chapter, question }) {
  return (
    <div>
      <HeaderWithIcon icon={chapter.illustration} title={chapter.title} />
      {_(chapter.subchapters).map((subchapter, index) => (
        <Subchapter
          key={`${underscored(subchapter.title)}-${index}`}
          question={question}
          subchapter={subchapter}
        />
      ))}
    </div>
  );
}

Chapter.propTypes = {
  chapter: PropTypes.shape({
    title: PropTypes.string.isRequired,
    illustration: PropTypes.string.isRequired
  }).isRequired,
  question: PropTypes.shape(questionPropType)
};

export default Chapter;
